import { createTheme } from "@mui/material/styles";

export const theme = (mode = "ligh") => {
  return createTheme({
    typography: {
      fontFamily: ["Lato", "sans-serif"].join(","),
      body1: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "1.1rem",
        },
        // backgroundColor:colors.grey["700"]
      },
      body2: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "0.7rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "1rem",
        },
        // color:colors.grey["700"]
      },
      body4: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1.1rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1.8rem",
        },
        
        // backgroundColor:colors.grey["700"]
      },
      body3: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "0.7rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "0.75rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "1rem",
        },
        // backgroundColor:colors.grey["700"]
      },
      h4: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1.4rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "2rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "2rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "2rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "2rem",
        },
        // color:colors.grey["700"]
      },
      h2: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1.3rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "1.1rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "1.3rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "1.3rem",
        },
        // color:colors.grey["700"]
      },
      h3: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1.8rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1.8rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "2rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "2rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "2rem",
        },
        // color:colors.grey["700"]
      },
      h1: {
        fontSize: "1rem",
        fontWeight: "400",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1.3rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "2rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "2.3rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "2.3rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "2.2rem",
        },
        // color:colors.grey["700"]
      },
      h5: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1.2rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1.5rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "1.5rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "1.5rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "1.5rem",
        },
      },
      h6: {
        fontSize: "1rem",
        [createTheme().breakpoints.up("xs")]: {
          fontSize: "1.4rem",
        },
        [createTheme().breakpoints.up("sm")]: {
          fontSize: "1.5rem",
        },
        [createTheme().breakpoints.up("md")]: {
          fontSize: "1.2rem",
        },
        [createTheme().breakpoints.up("lg")]: {
          fontSize: "1.5rem",
        },
        [createTheme().breakpoints.up("xl")]: {
          fontSize: "1.5rem",
        },
      },
    },

    palette: {
      mode: mode,

      primary: {
        main: "#fff",
      },
      secondary: {
        main: "rgba(0,0,0, 0.3)",
      },
      tertiary: {
        main: "#868686",
      },
      four: {
        main: "#484848",
      },
      five: {
        main: "#0E3347",
      },
      six: {
        main: "#20B69F",
      },
      default: {
        background: "#fff",
        paper: "#F2F2F2",
      },
    },
  });
};
